const adjs = [
    "woeful",
    "unsightly",
    "unpropitious",
    "unpleasant",
    "unlucky",
    "unfortunate",
    "unfavorable",
    "ugly",
    "troublesome",
    "tough",
    "threatening",
    "synthetic",
    "stinking",
    "somber",
    "shocking",
    "scary",
    "sad",
    "repulsive",
    "regrettable",
    "portentous",
    "poisonous",
    "poignant",
    "perverse",
    "pernicious",
    "painful",
    "oppressive",
    "ominous",
    "offensive",
    "obnoxious",
    "nasty",
    "nagging",
    "mournful",
    "morose",
    "mischievous",
    "malignant",
    "malign",
    "malevolent",
    "malefic",
    "lugubrious",
    "lowering",
    "injurious",
    "inauspicious",
    "ill-boding",
    "hurtful",
    "horrifying",
    "horrific",
    "horrid",
    "horrible",
    "horrendous",
    "hopeless",
    "hideous",
    "heart-wrenching",
    "harrowing",
    "harmful",
    "grungy",
    "gruesome",
    "gross",
    "grody",
    "grim",
    "grievous",
    "gloomy",
    "ghastly",
    "funereal",
    "frightful",
    "frightening",
    "foreboding",
    "fearful",
    "evil",
    "dreary",
    "dreadful",
    "doomful",
    "doleful",
    "distressing",
    "distressful",
    "disquieting",
    "dispiriting",
    "dismal",
    "dishonest",
    "disgusting",
    "disastrous",
    "dire",
    "depressive",
    "depressing",
    "deplorable",
    "deleterious",
    "corrupt",
    "bleak",
    "blackhearted",
    "baneful",
    "baleful",
    "bad",
    "awful",
    "atrocious",
    "appalling",
    "apocalyptic",
    "alarming",
    "afflictive",
    "adverse",
    "abominable",
]
const nouns = [
    "abasement",
    "abatement",
    "aberration",
    "abjection",
    "abjectness",
    "absurdity",
    "ache",
    "alarm",
    "annoyance",
    "anxiety",
    "awe",
    "backsliding",
    "blahs",
    "bleakness",
    "bummer",
    "cheerlessness",
    "comedown",
    "consternation",
    "craziness",
    "cropper",
    "decay",
    "decrepitude",
    "degeneracy",
    "degeneration",
    "dejection",
    "delirium",
    "delusion",
    "derangement",
    "descent",
    "desolation",
    "desperation",
    "despondency",
    "deterioration",
    "devolution",
    "diminution",
    "discomfiture",
    "discomposure",
    "discouragement",
    "dismay",
    "dispiritedness",
    "displeasure",
    "disquiet",
    "dissolution",
    "distress",
    "dive",
    "dole",
    "dolefulness",
    "dolor",
    "downfall",
    "downgrade",
    "downheartedness",
    "downturn",
    "dread",
    "dreariness",
    "drop",
    "dullness",
    "dumps",
    "dwindling",
    "ebb",
    "ebbing",
    "embarrassment",
    "enfeeblement",
    "ennui",
    "failing",
    "failure",
    "fall",
    "fanaticism",
    "fearfulness",
    "flop",
    "foolishness",
    "fright",
    "gloom",
    "gloominess",
    "hardship",
    "heavyheartedness",
    "hopelessness",
    "horror",
    "hurt",
    "hysteria",
    "inquietude",
    "intimidation",
    "irrationality",
    "lapse",
    "lowness",
    "lunacy",
    "malaise",
    "mania",
    "melancholia",
    "melancholy",
    "misery",
    "mortification",
    "neurosis",
    "nuisance",
    "panic",
    "phobia",
    "pratfall",
    "psychopathy",
    "psychosis",
    "qualm",
    "recession",
    "relapse",
    "sadness",
    "senility",
    "shock",
    "skids",
    "slump",
    "soreness",
    "sorrow",
    "stupidity",
    "trepidation",
    "trepidity",
    "trouble",
    "unbalance",
    "uneasiness",
    "unhappiness",
    "unpleasantness",
    "upset",
    "vapors",
    "vexation",
    "wane",
    "waning",
    "weakening",
    "woefulness",
    "worry",
]

export function generateDocName(): string {
    const adj = adjs[Math.floor(Math.random() * adjs.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    const adj_noun = `${adj} ${noun}`;
    return adj_noun.charAt(0).toUpperCase() + adj_noun.slice(1).toLowerCase();
}